import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-icon",
  "use": "arrow-icon-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-icon\">\r\n    <path d=\"M13.4763 9.1666L9.00634 4.6966L10.1847 3.51826L16.6663 9.99993L10.1847 16.4816L9.00634 15.3033L13.4763 10.8333H3.33301V9.1666H13.4763Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol